import { Col, Row, Tag } from "antd";
import { Link } from "react-router-dom";
import { formatDateMonthName } from "../../components/date/DateOp";
import { getDayDiffFromDates } from "../../types/TimeTypes";
import { SvgIcon } from "./SvgIcon";
import { clsx } from "clsx";
import classes from "./ExpirationDateCell.module.less";

interface ExpirationDateCellProps {
    orderFormId: number;
    date?: string;
    showLink?: boolean;
}

// How urgent the expiration is: more than 60 days out, within 60, within 30 or past.
const daysColorInterval = [
    { days: 60, className: classes.far },
    { days: 30, className: classes.soon },
    { days: 0, className: classes.due },
];

const getColorByDays = (days?: number) => {
    if (typeof days !== "number" || !days)
        return daysColorInterval[daysColorInterval.length - 1].className;
    for (const item of daysColorInterval) {
        if (item.days < days) return item.className;
    }
    return daysColorInterval[daysColorInterval.length - 1].className;
};

export const ExpirationDateCell: React.FC<ExpirationDateCellProps> = ({
    orderFormId,
    date,
    showLink,
}) => {
    const dayDiff = date ? getDayDiffFromDates(new Date(), new Date(date)) : 365;
    const urgency = getColorByDays(dayDiff);
    const label = date ? formatDateMonthName(date) : "None";

    const link = showLink ? (
        <Col>
            <Link to={`/order/${orderFormId}`}>
                <SvgIcon name="outlink" size={15} />
            </Link>
        </Col>
    ) : null;

    return (
        <Row gutter={8} wrap={false}>
            <Col flex={1}>
                <Tag className={clsx(classes.tag, urgency)}>{label}</Tag>
            </Col>
            {link}
        </Row>
    );
};
